export class NewsModel {
    public id: string;
    public titleId: string;
    public memo: string;
    public attachment: string;
    public countryId: any = null;
    public centreId: any  = null;
    public role: any = null;
    public ClinicLogoName: string;
    public IsClinicLogoDelete: boolean;
}

export class WorldTravelNews {
    id: string;
    memo: string;
    publiser: string;
    publishDate: Date;
    title: string;
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/centre/news.models.ts